<template>
  <div class="typography">
    <Hero
      class="hero"
      heading="Fonts"
    />
    <TextBlock  title="Fonts carry a lot of identity.">
      <p>
        The main typeface to be used is called <strong>Space Grotesk</strong>.
        This typeface should be used as headline typeface and
        for texts that are short and sweet.
      </p>
      <p>
        <strong>Source Serif</strong> is the secondary typeface used, which is
        different in contrast to Space Grotesk, and equally awesome.
        It's not that boring as it might seem, it's just used
        for longer content so it's easier to read.
      </p>
      <p>
        Source Serif should be used for longer content that wants
        to go a bit deeper and include more words, rows and columns.
        Easy to read, easy to sell.
      </p>
    </TextBlock>
    <PageContainer>
      <div class="font-container">
        <div class="font-examples">
          <div class="font1">
            <p>
              The Time to Act Is Now: Media Industry's Unique Position
              on Reducing the Internet's Carbon Dioxide Impact
            </p>
            <div class="font-names">
              <img src="/icons/circle-pointer.svg"/>
              <p>Space Grotesk - Bold</p>
            </div>
          </div>
          <div class="font2">
            <p>
              The climate crisis is more imminent than ever before, not
              excluding within the media industry. While professionals
              scramble to measure and reduce their impact by focusing on direct
              operational emissions, we argue for the urgent need to set common
              standards for indirect emissions stemming from digital advertising.
            </p>
            <div class="font-names">
              <img src="/icons/circle-pointer.svg"/>
              <p>Space Grotesk - Light</p>
            </div>
          </div>
          <div class="font3">
            <p>
              To learn more about the Internet's carbon footprint and our
              approach in reducing emissions, download our white paper and
              join us in the conversation about setting common standards, as
              well as implementing innovative technology solutions—it's the
              right thing to do for brands and the future of our planet.
            </p>
            <div class="font-names">
              <img src="/icons/circle-pointer.svg"/>
              <p>Source Serif - Light</p>
            </div>
          </div>
          <div class="font4">
            <p>
              Would you like to read the full white paper? Fill in your e-mail
              address and we will send you a download link.
            </p>
            <div class="font-names">
              <img src="/icons/circle-pointer.svg"/>
              <p>Source Serif - Semibold<br/>
              <span>(for high-lighting purposes only)</span></p>
            </div>
          </div>
        </div>
        <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/fonts/seenthis-fonts.zip">Download Font Pack</DownloadButton>
        <img class="slogans-image" src="/images/text-image.svg"/>
        <div class="slogans-text">
          <p>No file size restrictions, with maximum quality for every user</p>
          <p>Reduce</p>
          <p>Let's do this!</p>
          <p><strong>CO2</strong><br/>CO2<br/><strong>CO2</strong></p>
        </div>
      </div>
      <ViLinks />
    </PageContainer>
  </div>
</template>

<script>
import Hero from '../components/hero.vue';
import DownloadButton from '../components/download-button.vue';
import TextBlock from '../components/text-block.vue';
import PageContainer from '../components/page-container.vue';
import ViLinks from '../components/visual-id-links.vue';

export default {
  name: 'Inspiration',
  components: {
    DownloadButton,
    Hero,
    TextBlock,
    PageContainer,
    ViLinks,
  },
};
</script>


<style lang="stylus" scoped>
  @require '../style/colors'

  .font-container
    display: flex
    flex-direction: column
    align-items: center

  .font-examples
    max-width: 50rem
    margin-right: 50rem
    margin-bottom: 12rem
    background-color: $green30
    padding: 4rem 8rem

    p
      max-width: 47rem

    .fonts
      position: relative
      display: flex
      align-items: center
      justify-content: center

      .font-names
        position: absolute
        left: 104%
        display: flex
        font-size: 2.8rem
        z-index: 2

        img
          max-width: 20rem

        p
          margin: 0 0 0 3rem
          width: 35rem

    .font1
      @extend .fonts
      font-size: 4rem
      font-weight: 700

    .font2
      @extend .fonts
      font-size: 2.5rem
      font-weight: 300

    .font3
      @extend .fonts
      font-family: source-serif
      font-size: 2rem
      font-weight: 300

    .font4
      @extend .fonts
      font-family: source-serif
      font-size: 2rem
      font-weight: 600

      span
        font-size: 2rem

    @media only screen and (max-width: 1100px)
      flex-direction: column
      margin-right: 0

      .fonts
        margin-bottom: 10rem

        .font-names
          left: 0
          bottom: -4rem
          font-size: 1.6rem

          p
            width: 100%

            span
              font-size: 1.4rem

      // Removes extra white-space from first text-block
      .font1
        margin-bottom: 8rem

        .font-names
          bottom: -2rem

      // Prohibits linebreak
      .font4 .font-names p
        margin-right: -2rem

    @media only screen and (max-width: 600px)
      padding: 2.5rem 4rem
      .fonts
        flex-direction: column
        padding-bottom: 1rem

        .font-names
          display: flex
          flex-direction: column-reverse

          img
            max-width: 23rem

          p
            margin-left: 4rem
            margin-bottom: -0.5rem

      .font4 .font-names
        bottom: -6rem

  .slogans-image
    width: 96%
    max-width: 90rem
    margin: 9rem 0 4rem 0

    @media only screen and (max-width: 600px)
      display: none

  .slogans-text
    max-width: 40rem
    text-align: center
    margin: 12rem 0 2rem 0

    p
      margin: 0
      margin-bottom: 1.5rem
      padding: 2rem

    p:first-of-type
      padding: 8rem 2rem
      font-size: 3rem
      font-weight: 300
      color: $secondary-color
      background-color: $blue

    p:nth-of-type(2)
      padding: 5rem 2rem
      font-size: 3rem
      font-weight: 700
      color: $black
      background-color: $secondary-color

    p:nth-of-type(3)
      padding: 2.5rem 2rem
      font-size: 4rem
      font-weight: 700
      color: $white
      background-color: $primary-color

    p:last-of-type
      padding: 3rem 2rem
      font-size: 8rem
      line-height: 7rem
      color: $white
      background-color: $green

    @media only screen and (min-width: 600px)
      display: none

</style>
